import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { map } from 'rxjs';
import { deepCopy } from 'src/services/util';

@Component({
    selector: 'formly-multi-select-field',
    template: `
    <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" *ngIf="to.label">{{ to.label }}</label>
    <ng-select
            [items]="items"
            [multiple]="true"
            [closeOnSelect]="false"
            [hideSelected]="true"
            bindLabel="name"
            placeholder="Select people"
            [formControl]="formControl"
            [classList]="'bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 mb-3'"
           >
    </ng-select>
  `,
})
export class MultiSelectType extends FieldType<FieldTypeConfig> {
    selected = []
    items!: any[];

    ngOnInit() {
        if (Array.isArray(this.to.options)) {
            this.to.options = this.items;
        } else {
            let options = this.to.options
            options?.subscribe((filteredOptions: any[]) => {
                this.items = filteredOptions;
            });
        }
    }
}
